<template>
  <div class="container">
    <div @click="fnShowVoucher" class="goods-info-voucher-wrap">
      <div @click.stop class="content">
        <div class="head">
          <div>
            <div class="text">优惠</div>
            <!-- <img @click="fnShowVoucher" alt class="close" :src="`${$cdnImageUrl}/cart/icon-close.png`" /> -->
            <!-- <img @click="fnShowVoucher" alt class="close"  src="@/assets/imgs/common/control-close.png" /> -->
            <svg class="icon-svg close" aria-hidden="true" v-on:click="fnShowVoucher">
              <use :xlink:href="$globalIcon.closeIconNew"></use>
            </svg>
          </div>
        </div>
        <div class="scroll-view">
          <template v-if="rightsList.length">
            <div class="head-title">权益<span v-if="showNotice">(此权益为收货人权益)</span></div>
            <div class="right-list" v-if="rightsData.rightsTopList.length">
              <div class="rights-top">买即送<span>先到先得（以提交订单为准）</span></div>
              <div class="rights-row" v-for="item in rightsData.rightsTopList" :key="item.rightsNo">
                <div class="right-tag">权益</div>
                <div class="right-content">{{item.rightsName}}</div>
              </div>
            </div>
            <div class="right-list" v-if="rightsData.rightsBottomList.length">
              <div class="rights-top">可选权益<span>以下权益与其他权益不可同享（以提交订单为准）</span></div>
              <div class="rights-row" v-for="item in rightsData.rightsBottomList" :key="item.rightsNo">
                <div class="right-tag right-tag-blue">权益</div>
                <div class="right-content">{{item.rightsName}}</div>
              </div>
            </div>
            <div class="btn-fold" v-if="rightsList.length > 5" @click="rightsFold = !rightsFold">
              {{rightsFold ? '查看全部权益' : '收起'}}
            </div>
          </template>
          <template v-if="discountActivityText?.length">
            <div class="head-title">促销</div>
            <div class="discount-list" @click="goShopDetail">
              <div class="discount-tag">{{discountActivityInfo.discountType == 1 ? '凑单' : '满减'}}</div>
              <div class="discount-content">{{discountActivityText}}</div>
              <svg class="icon-svg more-icon" aria-hidden="true">
                <use xlink:href="#icon-universal_more1"></use>
              </svg>
            </div>
          </template>
          <template v-if="voucherListCanReceiveOnly.length">
            <div class="head-title">优惠券</div>
            <div class="head-tips" v-if="getGoodsUseCouponInfo.type">
              <p>使用以下
                <img v-if="getGoodsUseCouponInfo.type == 'sheng'" :src="`${$cdnImageUrl}/goodsDetail/quan_sheng_icon.png`" alt="">
                <img v-else-if="getGoodsUseCouponInfo.type == 'cou'" :src="`${$cdnImageUrl}/goodsDetail/quan_cou_icon.png`" alt="">
                标优惠券，<span v-if="getGoodsUseCouponInfo.type =='cou'">买{{getGoodsUseCouponInfo.buyNum}}件</span>预估到手价<strong>￥{{getGoodsUseCouponInfo.price.toFixed(2)}}</strong></p>
              <h4>可领优惠券</h4>
            </div>
            <div class="voucher-list">
              <van-list v-model="loading" :finished="finished" :immediate-check="false">
                <div class="li voucher-list-item" v-for="(item, index) in voucherListCanReceiveOnly" :key="index">
                  <coupon-item :couponData="item" @receive="fnReceiveVoucher(item,index,$event)"></coupon-item>
                  <!-- <div class="left">
                    <img alt :src="`${$cdnImageUrl}/cart/yhq-bg-left-w.png`" />
                    <div class="bg">
                      <div class="value">
                        ￥
                        <span :class="{fz:item.couponValue>=1000}">{{ item.couponValue }}</span>
                      </div>
                      <div class="voucher-list-item-info">
                        <div class="condition">
                          <div class="tag">{{item.couponFrom === '2' ? '优惠券' : item.couponType === 1 ? '平台券' : '店铺券' }}</div>
                          <span>{{ item.minAmountDoc }}</span>
                        </div>
                        <p>{{ item.couponTitle }}</p>
                        <div class="effective">{{ item.startTime }}—{{ item.endTime }}</div>
                      </div>
                    </div>
                    <img alt :src="`${$cdnImageUrl}/cart/yhq-bg-right-w.png`" />
                  </div>
                  <div class="right">
                    <div class="bg-box">
                      <img alt :src="`${$cdnImageUrl}/cart/yhq-bg-left-o.png`" />
                      <div class="bg"></div>
                      <img alt :src="`${$cdnImageUrl}/cart/yhq-bg-right-o.png`" />
                    </div>
                    <img alt class="received" :src="`${$cdnImageUrl}/cart/yhq-yl.png`" v-if="item.displayType === '2'" />
                    <div class="unaccalimed" v-if="item.displayType === '1'" @click="fnReceiveVoucher(item,index)">
                      点击
                      <br />领取
                    </div>
                    <img alt class="received" src="@/assets/imgs/shop/yhq-yqg.png" v-if="item.displayType === '5'" />
                  </div> -->
                </div>
              </van-list>
            </div>
          </template>
          <template v-if="voucherGiftList.length">
            <div class="head-title">礼品券</div>
            <div class="head-tips">
              <h4>可领礼品券</h4>
            </div>
            <div class="voucher-list">
              <van-list v-model="loading" :finished="finished" :immediate-check="false">
                <div class="li voucher-list-item" v-for="(item, index) in voucherGiftList" :key="index">
                  <coupon-item :couponData="item" @receive="fnReceiveVoucher(item,index,$event)"></coupon-item>
                </div>
              </van-list>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import couponItem from './coupon-item.vue'
import { mapGetters } from 'vuex'
import { UserRoleEnum } from '@/config/constMaps'

export default {
  components: { couponItem },
  props: ['voucherList', 'voucherGiftList', 'finished', 'getGoodsUseCouponInfo', 'rightsList', 'discountActivityInfo', 'discountActivityText'],
  data() {
    return {
      loading: false,
      rightsFold: true
    }
  },
  methods: {
    fnShowVoucher() {
      this.$emit('fnShowVoucher')
    },
    fnReceiveVoucher(data, index, e) {
      // 判断是否登录 没登录跳转登录页面
      if (!this.$store.getters.getLoginStatus) {
        this.$store.dispatch('doLogin')
        return
      }
      // 已领取
      if (data.displayType === 2) {
        return
      }
      console.log(data, index, e, 'fnReceiveVoucher')
      this.receiveCoupon({
        activityCode: data.activityCode,
        couponTemplateCode: data.couponTemplateCode,
        sourceChannel: data.sourceChannel,
        index: index,
        ...data,
        ...e
      })
    },
    receiveCoupon(data) {
      this.$emit('receiveCoupon', data)
    },
    goShopDetail() {
      this.$emit('goShopDetail')
    }
  },
  computed: {
    ...mapGetters(['getUserIdentifyInfo']),
    voucherListCanReceiveOnly() {
      // 过滤掉暗券
      return this.voucherList.filter(v => v.productUsingCouponType !== 1)
    },
    showNotice() {
      // 商家、店铺合伙人、项目经理、直销员、店长、社区专员
      let identifySet = new Set(this.getUserIdentifyInfo?.identifySet || [])
      return identifySet.has(UserRoleEnum.STORE_MASTER) || identifySet.has(UserRoleEnum.STORE_PARTNER) || identifySet.has(UserRoleEnum.PM) || identifySet.has(UserRoleEnum.SHOP_OWNER) || identifySet.has(UserRoleEnum.COMMUNITY_OFFICER)
      // return [1, 2].includes(this.getUserIdentifyInfo?.category) || (this.getUserIdentifyInfo?.merchantAccountVo?.merchantAccountRoles || []).some(v => v.code === 19 || v.code === 0)
    },
    rightsData() {
      let rightsData = {
        rightsTopList: [],
        rightsBottomList: []
      }

      this.rightsList.forEach((right, index) => {
        if (!(this.rightsFold && index > 4)) {
          if (right.isShare) {
            rightsData.rightsTopList.push(right)
          } else {
            rightsData.rightsBottomList.push(right)
          }
        }
      });

      return rightsData
    }
  }
}
</script>
<style>
.van-list__error-text,
.van-list__finished-text,
.van-list__loading {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.scroll-view {
  height: 8.9rem;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  .head-title {
    margin-bottom: 8px;
    font-size: 14px;
    color: #999;
    line-height: 22px;
  }
  .right-list {
    margin-bottom: 16px;
    font-size: .2rem;
    color: #333;
    .rights-top {
      font-weight: 500;
      span {
        color: #999;
        margin-left: 4px;
      }
    }
    .rights-row {
      display: flex;
      margin-top: 6px;
      width: 100%;
      .right-tag {
        background: rgba(255,82,82,0.15);
        color: #FF5252;
        width: 31px;
        height: 14px;
        border-radius: 7px;
        line-height: 14px;
        text-align: center;
        margin-right: 4px;
      }
      .right-tag-blue {
        background: rgba(40,120,255,0.15);
        color: #2878FF;
      }
      .right-content {
        line-height: 14px;
        max-width: 275px;
        @include text-overflow(2);
      }
    }
  }
}
.btn-fold {
  width: 89px;
  height: 24px;
  border: 1px solid #999999;
  border-radius: 12px;
  text-align: center;
  line-height: 24px;
  font-size: 0.24rem;
  color: #333;
  margin: 0 auto;
}

.container{
  height: 10.7rem;
  overflow: hidden;
  position: relative;
}
.goods-info-voucher-wrap {
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // z-index: 2560;
  // background: rgba(0, 0, 0, 0.7);
}
.goods-info-voucher-wrap .content {
  background-color: white;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 10.7rem;
  padding: 0.2rem 0 0.2rem 0.32rem;
  border-radius: 0.16rem 0.16rem 0 0;
  box-sizing: border-box;
}
.goods-info-voucher-wrap .content .scroll-view {
  padding-right: 0.32rem;
}
.goods-info-voucher-wrap .content .head {
  // font-size: 0.34rem;
  // color: rgba(0, 0, 0, 1);
  // line-height: 0.88rem;
  // height: 0.88rem;
  // text-align: center;
  position: relative;
  margin-bottom: 0.24rem;
}

.goods-info-voucher-wrap .content .head .text {
  font-size: 0.34rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 0.48rem;
}
.goods-info-voucher-wrap .content .head .close {
  position: absolute;
  right: 0.24rem;
  display: inline-block;
  width: 0.26rem;
  height: 0.26rem;
  top: 0.12rem;
}

.head-tips{
  margin-top: .1rem;
  p{
    padding-bottom: .1rem;
    font-size: .2rem;
    color: #333;
    img{
      display: inline;
      margin: 0 2px;
      width: .36rem;
      height: .36rem;
      vertical-align: middle;
    }
    strong{
      font-weight: 500;
    }
  }
}

.goods-info-voucher-wrap .content .voucher-list {
  // padding-left: 0.32rem;
  // padding-right: 0.32rem;
  // padding-bottom: 0.16rem;
}
.goods-info-voucher-wrap .content .voucher-list p.text {
  // padding-top: 0.24rem;
  // padding-bottom: 0.24rem;
  // font-size: 0.28rem;
  // color: rgba(51, 51, 51, 0.87);
  // line-height: 0.4rem;
  font-size: 0.28rem;
  font-weight: 400;
  color: rgba(51,51,51,0.87);
  line-height: 0.44rem;
  // margin-top: 0.44rem;
}
.goods-info-voucher-wrap .content .voucher-list .van-list {
  margin-top: 0.16rem;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.24rem;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item:last-child {
  margin-bottom: 0;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item img {
  width: 0.2rem;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left {
  display: flex;
  height: 1.8rem;
  flex: 1;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left .bg {
  flex: 1;
  background-color: #fff;
  display: flex;
  align-items: center;
  height: 1.8rem;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left .bg .value {
  font-size: 0.32rem;
  font-weight: 300;
  color: $themeSynRed;
  line-height: 0.38rem;
  padding-left: 0.1rem;
  width: 2.2rem;
  box-sizing: border-box;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left .bg .value span {
  height: 0.96rem;
  font-size: 0.8rem;
  line-height: 0.96rem;
  font-family: Impact;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left .bg .value span.fz {
  height: 0.96rem;
  font-size: 0.6rem;
  line-height: 0.96rem;
  font-family: Impact;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left .bg .voucher-list-item-info {
  flex: 1;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left .bg .voucher-list-item-info .condition {
  display: flex;
  align-items: center;
  color: $themeSynRed;
  font-size: 0.24rem;
  line-height: 0.34rem;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left .bg .voucher-list-item-info .condition .tag {
  height: 0.36rem;
  box-sizing: border-box;
  border-radius: 0.18rem;
  border: 1px solid $themeSynRed;
  padding-left: 0.12rem;
  padding-right: 0.12rem;
  margin-right: 0.14rem;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left .bg .voucher-list-item-info p {
  font-size: 0.22rem;
  color: rgba(51, 51, 51, 0.87);
  line-height: 0.32rem;
  margin-top: 0.15rem;
  margin-bottom: 0.06rem;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .left .bg .voucher-list-item-info .effective {
  font-size: 0.24rem;
  color: rgba(153, 153, 153, 1);
  line-height: 0.34rem;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .right {
  height: 1.8rem;
  width: 1.38rem;
  position: relative;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .right .bg-box {
  display: flex;
  height: 1.8rem;
  width: 1.38rem;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .right .bg-box .bg {
  flex: 1;
  background: $themeSynRed;
  height: 1.8rem;
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .right .unaccalimed {
  font-size: 0.28rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.87);
  line-height: 0.36rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.goods-info-voucher-wrap .content .voucher-list .voucher-list-item .right .received {
  width: 1.24rem;
  height: 1.24rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.goods-info-voucher-wrap .content .discount-list {
  margin-bottom: 16px;
  font-size: .2rem;
  color: #333;
  display: flex;
  position: relative;
  padding-right: 0.28rem;
  .discount-tag {
    background: rgba(255,82,82,0.15);
    color: #FF5252;
    width: 0.62rem;
    min-width: 0.62rem;
    height: 0.28rem;
    border-radius: 0.14rem;
    line-height: 0.28rem;
    text-align: center;
    margin-right: 0.08rem;
  }
  .discount-content {
    line-height: 0.28rem;
    @include text-overflow(2);
    display: flex;
    flex-wrap: wrap;
  }
  .more-icon {
    width: 0.24rem; 
    height: 0.24rem;
    color: #333;
    position: absolute;
    right: 0rem;
  }
}
</style>
